import { Box } from '@mui/material';

import type { SpotHistoryTableColumnType } from '@/types/markets';

import { COLUMN_GAP, COLUMN_PADDING_X, DATE_COLUMN_WIDTH } from './constants';
import type { DisplayRow, VirtualCell } from './types';
import { getColumnCode } from './utils';

type Props = {
  row: DisplayRow;
  rowIndex: number;
  virtualRow: VirtualCell;
  virtualColumns: VirtualCell[];
  columns: SpotHistoryTableColumnType[];
  totalWidth: number;
};

const DataRow = ({ row, rowIndex, virtualRow, virtualColumns, columns, totalWidth }: Props) => {
  const backgroundColor = rowIndex % 2 === 0 ? 'gx.tileLight' : 'background.paper';

  return (
    <Box
      aria-rowindex={rowIndex + 2}
      role='row'
      sx={{
        backgroundColor,
        height: virtualRow.size,
        left: 0,
        position: 'absolute',
        top: virtualRow.start,
        width: totalWidth
      }}
    >
      <Box
        aria-colindex={1}
        role='rowheader'
        sx={{
          alignItems: 'center',
          backgroundColor,
          color: 'text.primary',
          display: 'flex',
          fontSize: 14,
          height: '100%',
          left: 0,
          position: 'sticky',
          px: COLUMN_PADDING_X,
          whiteSpace: 'nowrap',
          width: DATE_COLUMN_WIDTH,
          zIndex: 2
        }}
      >
        {row.formattedDate}
      </Box>
      {virtualColumns.map(virtualColumn => {
        const column = columns[virtualColumn.index - 1];
        const columnCode = getColumnCode(column);

        return (
          <Box
            key={`${row.date}-${rowIndex}-${columnCode || virtualColumn.index}`}
            aria-colindex={virtualColumn.index + 1}
            role='cell'
            data-resize-col={columnCode}
            data-resize-col-order={virtualColumn.index}
            sx={{
              alignItems: 'center',
              color: 'text.primary',
              display: 'flex',
              fontSize: 14,
              height: '100%',
              justifyContent: 'center',
              left: virtualColumn.start,
              px: COLUMN_PADDING_X,
              position: 'absolute',
              top: 0,
              whiteSpace: 'nowrap',
              width: virtualColumn.size - COLUMN_GAP
            }}
          >
            {row.values[virtualColumn.index - 1] ?? '-'}
          </Box>
        );
      })}
    </Box>
  );
};

export default DataRow;
